import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';

// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { ILabel } from '../../../node/repositories/newbuilding-card/entities/reviews/Label';

export interface IReviewLabelsProps {
  labels: ILabel[];
}

export const ReviewLabels: React.FC<IReviewLabelsProps> = ({ labels }) => {
  return <Label background={labels[0].color as TColors}>{labels[0].text}</Label>;
};
